import { Component } from 'react';

export default class BaseAllTimePage extends Component {
  setQueryParam(param, value) {
    const query = new URLSearchParams(this.props.history.location.search);
    query.set(param, value);
    this.props.history.push({ search: query.toString() });
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/statistics/common/baseAllTimePage.js